import { render, staticRenderFns } from "./TrainingInternalFeedbackForm.vue?vue&type=template&id=1150fbb2&"
import script from "./TrainingInternalFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./TrainingInternalFeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports